import { gql } from '@apollo/client';

export default gql`
  mutation UpdatePanel($id: Int!, $panelPatch: PanelPatch!) {
    updatePanelById(input: { id: $id, panelPatch: $panelPatch }) {
      panel {
        id
        endTime
      }
    }
  }
`;
